import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import { JournalEntryCreate } from '../interfaces/accounting.interface';

export const JournalEntryService = {
    getEntriesByInstitution: async (page: number = 0, size: number = 10) => {
        const institutionId = AuthService.getSelectedInstitution();
        const response = await axios.get(`${ENDPOINTS.JOURNAL_ENTRY.LIST_BY_INSTITUTION(institutionId!)}?page=${page}&size=${size}`);
        return response.data;
    },
    getEntryById: async (id: string) => {
        const response = await axios.get(ENDPOINTS.JOURNAL_ENTRY.BY_ID(id));
        return response.data;
    },
    createEntry: async (entry: JournalEntryCreate) => {
        const response = await axios.post(ENDPOINTS.JOURNAL_ENTRY.BASE, entry);
        return response.data;
    },
    postEntry: async (id: string) => {
        const response = await axios.patch(ENDPOINTS.JOURNAL_ENTRY.POST(id));
        return response.data;
    },
    voidEntry: async (id: string) => {
        const response = await axios.patch(ENDPOINTS.JOURNAL_ENTRY.VOID(id));
        return response.data;
    },
};
